module.exports = __webpack_public_path__ + "img/mpsgn.8506ef73.svg";